const initialState = {
  isSelect: '',
};

export const selectClinicReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_IS_SELECT':
      return { ...state, isSelect: action.payload };
    default:
      return state;
  }
};
